import * as React from 'react';

export type ReducedMotionState = {
  /** Whether animations are off now, from the user's choice or the device for `system`. */
  isReduced: boolean;
  /** What the device itself asks for, live; for telling the user what "as on device" means. */
  isDeviceReduced: boolean;
};

/** Set by `ReducedMotionProvider`; undefined outside one. */
export const ReducedMotionContext = React.createContext<ReducedMotionState | undefined>(undefined);

function useReducedMotionState() {
  const state = React.useContext(ReducedMotionContext);

  if (state === undefined) {
    throw new Error('Reduced motion is read inside a ReducedMotionProvider');
  }

  return state;
}

/** True when animations are off; for motion CSS can't reach, such as a map's camera or a video. */
export function useIsMotionReduced() {
  return useReducedMotionState().isReduced;
}

/** True when the device asks for reduced motion, whatever the user chose in the app. */
export function useIsDeviceMotionReduced() {
  return useReducedMotionState().isDeviceReduced;
}
